import qs from 'query-string';
import { DeleteRelation } from '@/config/types';
import showError from '@/handler/error';
import { apiConfig } from '../api-config';

export const deleteMonitoring = async (params: DeleteRelation) => {
  const query = qs.stringify(params);

  try {
    const response = await apiConfig
      .post(
        `api/TerritoryAccess/delete?${query}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

    return response.data;
  } catch (err) {
    return showError(err);
  }
};
